import IAttivita, { exampleAttivita } from "./IAttivita";
import IScheda, { exampleScheda } from "./IScheda";

export default interface IOsservazione {
    Id: number;
    Id_Anagrafica: number;
    Anno: string;
    Num: number;
    Creation: string;
    Timestamp: string;

    //* NotMapped
    Schede: IScheda[];
    Attivita: IAttivita[];
}

export const exampleOsservazione: IOsservazione = {
    Id: 0,
    Id_Anagrafica: 0,
    Anno: '',
    Num: 0,
    Creation: '',
    Timestamp: '',

    Schede: [],
    Attivita: [],
};
